export enum BaseURL {
  PROD = "https://edu-app-server.onrender.com",
  DEV = "http://localhost:3001",
}
